import React from 'react';
import './cardTitle.less';

const CardTitle = ({ title }) => <div className='card-title'>{title}</div>;

export default CardTitle;



// WEBPACK FOOTER //
// ./src/react/card/CardTitle.jsx